<script setup>
import {chatChannels as channels} from "@/chatChannels.js";

defineProps({
    modelValue: String,
})
defineEmits(['update:modelValue'])
</script>

<template>
    <div class="bg-deep-blue overflow-auto rounded-lg px-1.5 py-0.5 gap-2 flex without-scrollbars">
        <button
            v-for="channel in channels"
            :key="channel.value"
            :class="[channel.value === modelValue && 'bg-sky-600']"
            class="py-1.5 rounded-lg min-w-fit px-3 flex shadow-[inset_1px_-3px_2px_rgba(0,0,0,0.3)] items-center gap-1"
            @click="$emit('update:modelValue', channel.value)"
        >
            <span class="font-sans whitespace-nowrap font-medium text-sky-200 text-sm">
                {{ $t(channel.label) }}
            </span>
        </button>
    </div>
</template>

<style>
.without-scrollbars::-webkit-scrollbar {
    display: none;
}

.without-scrollbars {
    scrollbar-width: none;
    -ms-overflow-style: none;
}
</style>
